import { PRIMARY } from '../../styles';

export default {
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: PRIMARY,
    backgroundImage: `url(/images/tile.png)`,
    backgroundRepeat: 'repeat',
    height: '100vh',
  },
  logoContainer: {
    textAlign: 'center',
    paddingBottom: 30,
  },
  email: {
  },
  password: {
  },
  inputs: {
    display: 'flex',
    flexDirection: 'column',
    width: 600,
    backgroundColor: 'white',
    opacity: 0.9,
    padding: 20,
  },
  input: {
    margin: 5,
    flex: 1,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  paper: {
    padding: 30,
  },
  signup: {
    marginTop: 30,
    width: 250,
  },
  login: {
    marginTop: 30,
    width: 250,
  },
};



// WEBPACK FOOTER //
// ./src/components/Authentication/AddAccountDialog/styles.js